<template>
  <div class="column" :style="backgroundColorStyle">
    <div class="column__section">
      <v-tooltip top bottom max-width="250px">
        <template v-slot:activator="{ on }">
          <span v-on="on" class="column__value">{{ value.percentage }}</span>
        </template>
        <span>
          {{
            $t(
              "message.reviews.categories.gridColumns.sentiment.sentimentScoreTooltip"
            )
          }}
        </span>
      </v-tooltip>
      <span>{{ label }}</span>
      <v-tooltip v-if="showComparisonArrow" bottom max-width="250px">
        <template v-slot:activator="{ on }">
          <v-icon
            v-on="on"
            :class="{ 'arrow-down': isLowerValue }"
            color="black"
            size="17"
            >icon-arrow</v-icon
          >
        </template>
        <span>{{ tooltip }}</span>
      </v-tooltip>
    </div>
  </div>
</template>

<script>
const COLUMNS_HIDDEN_ARROW = ["sentiment", "period_sentiment"];
export default {
  name: "ReviewsCategoriesTriadTableColumn",
  props: {
    value: {
      type: Object,
      required: true
    },
    item: {
      type: Object,
      required: true
    },
    colors: {
      type: Array,
      required: true
    },
    columnName: {
      type: String,
      required: true
    },
    isComparisonEnabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    backgroundColorStyle() {
      return {
        backgroundColor: this.colors[this.value.percentage + 100]
      };
    },
    label() {
      return this.$t(`message.sentiment.${this.value.label.toLowerCase()}`);
    },
    tooltip() {
      if (this.isComparisonEnabled) {
        return this.isLowerValue
          ? this.$t(
              "message.reviews.categories.sentimentRateComparisonLowerTooltip"
            )
          : this.$t(
              "message.reviews.categories.sentimentRateComparisonHigherTooltip"
            );
      }
      return this.isLowerValue
        ? this.$t("message.reviews.categories.sentimentRateLowerTooltip")
        : this.$t("message.reviews.categories.sentimentRateHigherTooltip");
    },
    sentiment() {
      return this.item.sentiment.percentage;
    },
    periodSentiment() {
      return this.item.period_sentiment.percentage;
    },
    selectedPeriodSentiment() {
      return this.item.selected_period_sentiment.percentage;
    },
    isArrowVisibleInComparison() {
      return !COLUMNS_HIDDEN_ARROW.includes(this.columnName);
    },
    isArrowVisibleInBase() {
      return this.columnName !== "sentiment";
    },
    isLowerValue() {
      if (this.isComparisonEnabled) {
        return (
          this.columnName === "period_sentiment" &&
          this.selectedPeriodSentiment > this.periodSentiment
        );
      }
      return this.isArrowVisibleInBase && this.periodSentiment < this.sentiment;
    },
    showComparisonArrow() {
      if (this.isComparisonEnabled) {
        return (
          this.columnName === "period_sentiment" &&
          this.periodSentiment !== this.selectedPeriodSentiment
        );
      }

      return (
        this.isArrowVisibleInBase &&
        this.periodSentiment !== this.sentiment &&
        this.sentiment !== 0
      );
    }
  },
  methods: {
    formattedNumber(value) {
      return this.$options.filters.formatNumber(value);
    },
    formatValue(value, unit = "") {
      return !value ? "-" : `${value}${unit}`;
    }
  }
};
</script>

<style lang="scss" scoped>
.column {
  position: absolute;
  left: $spacing * 0.5;
  top: $spacing * 0.5;
  height: calc(100% - 8px);
  width: calc(100% - 8px);
  display: flex;
  align-items: center;
  padding: $spacing * 2;
  justify-content: center;

  &__section {
    display: flex;
    align-items: center;
    gap: $spacing;
  }

  &__value {
    font-weight: 700;
  }
}
.arrow-down {
  transform: rotate(180deg);
}
</style>
